import { Component, OnInit, ViewChild } from "@angular/core";
@Component({
  selector: "app-view-payment-modal",
  templateUrl: "./view-payment-modal.component.html",
  styleUrls: ["./view-payment-modal.component.css"],
})
export class ViewPaymentModalComponent implements OnInit {
  @ViewChild("modalRef") modalRef;

  // data
  payment;

  ngOnInit() {}

  public open(payment) {
    this.payment = payment;
    this.modalRef.open();
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/claims-view/modals/view-payment-modal/view-payment-modal.component.ts